export default __webpack_public_path__ + "static/media/selfie.bf488e54.jpg";